module.exports = __webpack_public_path__ + "media/icons/download-app-store-light-ed4d9d11.svg";